import { useTranslation } from 'react-i18next';
import styles from './inforButtonHelperText.module.scss';

export type InfoButtonHelperTextProps = {
  buttonId: string;
};

const InfoButtonHelperText = ({ buttonId }: InfoButtonHelperTextProps) => {
  const { t } = useTranslation();

  return (
    <label
      className={`text-nowrap mb-0 ${styles.InfoButtonHelperText}`}
      htmlFor={buttonId}
    >
      {t('content.intake.questionFieldLabel')}
    </label>
  );
};

export default InfoButtonHelperText;
